module.exports = __webpack_public_path__ + "static/flatart_ai_studio_header_01-3bbaff8c2c5deabeac4a5450d1fa9071.webp";